import React from 'react';
import PropTypes from 'prop-types';

export const Info = ({ style }) => {
  return <img style={style} alt="Info" src={require('./info.svg').default} />;
};

Info.propTypes = {
  style: PropTypes.object,
};

export const BlackLogo = ({ style }) => {
  return <img style={style} alt="logo" src={require('./black_logo.png').default} />;
};

BlackLogo.propTypes = {
  style: PropTypes.object,
};

export const InterpretationIcon = ({ style }) => {
  return <img style={style} alt="logo" src={require('./Liity.svg').default} />;
};

export const SendIcon = ({ style }) => {
  return <img style={style} alt="send" src={require('./send.svg').default} />;
};

export const NoMessagesIcon = () => {
  return (
    <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(4 5)">
          <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="m21 14-3-3h-7c-.5522847 0-1-.4477153-1-1v-6c0-.55228475.4477153-1 1-1h9c.5522847 0 1 .44771525 1 1z" />
            <path d="m14 15v2c0 .5522847-.4477153 1-1 1h-7l-3 3v-10c0-.5522847.44771525-1 1-1h2" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MessagesIcon = () => {
  return (
    <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(4 5)">
          <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="m21 14-3-3h-7c-.5522847 0-1-.4477153-1-1v-6c0-.55228475.4477153-1 1-1h9c.5522847 0 1 .44771525 1 1z" />
            <path d="m14 15v2c0 .5522847-.4477153 1-1 1h-7l-3 3v-10c0-.5522847.44771525-1 1-1h2" />
          </g>
        </g>
      </g>
      <circle cx="24" cy="6" r="4.5" stroke="#EEE" strokeWidth="1" fill="#DC2C48" />
    </svg>
  );
};

export const Calendar = ({ style }) => {
  return <img style={style} alt="calendar" src={require('./calendar.svg').default} />;
};

export const Clock = ({ style }) => {
  return <img style={style} alt="time" src={require('./clock.svg').default} />;
};

export const CameraOffIcon = ({ style }) => {
  return <img style={style} alt="camera off" src={require('./camera-off.svg').default} />;
};

export const CameraOnIcon = ({ style }) => {
  return <img style={style} alt="camera on" src={require('./camera-on.svg').default} />;
};

export const MicOffIcon = ({ style }) => {
  return <img style={style} alt="mute on" src={require('./mic-off.svg').default} />;
};

export const MicOnIcon = ({ style }) => {
  return <img style={style} alt="mute off" src={require('./mic-on.svg').default} />;
};

export const VolumeOff = ({ style }) => {
  return <img style={style} alt="volume off" src={require('./volume-x.svg').default} />;
};

export const VolumeLow = ({ style }) => {
  return <img style={style} alt="volume low" src={require('./volume.svg').default} />;
};

export const VolumeMed = ({ style }) => {
  return <img style={style} alt="volume medium" src={require('./volume-1.svg').default} />;
};

export const VolumeHigh = ({ style }) => {
  return <img style={style} alt="volume high" src={require('./volume-2.svg').default} />;
};

export const MoreHorizontal = ({ style }) => {
  return <img style={style} alt="more" src={require('./more-horizontal.svg').default} />;
};

export const UserWhite = ({ style }) => {
  return <img style={style} alt="User" src={require('./userWhite.svg').default} />;
};

export const UserIcon = () => {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        transform="translate(1, 1)"
      >
        <rect id="Rectangle" x="7.875" y="5.625" width="8.25" height="10.5" rx="4.125"></rect>
        <circle id="Oval" cx="12" cy="12" r="12"></circle>
        <path d="M4.4635078,21.0522447 L4.4635078,20.0337674 C4.61937063,18.9252931 5.10580642,18.1432646 5.92281516,17.6876819 C6.7398239,17.2320993 8.12838812,16.4786202 10.0885078,15.4272447"></path>
        <path
          d="M14.4033673,21.0522447 L14.4033673,20.0337674 C14.5488393,18.9252931 15.002846,18.1432646 15.7653875,17.6876819 C16.527929,17.2320993 17.8239223,16.4786202 19.6533673,15.4272447"
          transform="translate(17.028367, 18.239745) scale(-1, 1) translate(-17.028367, -18.239745) "
        ></path>
      </g>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ margin: 'auto' }}
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
};

export const AspectRatio_4_3 = () => {
  return (
    <img
      style={{ height: '100%', visibility: 'hidden' }}
      alt=""
      src={require('./aspect_4_3.svg').default}
    />
  );
};

Calendar.propTypes = {
  style: PropTypes.object,
};

Clock.propTypes = {
  style: PropTypes.object,
};

InterpretationIcon.propTypes = {
  style: PropTypes.object,
};

BlackLogo.propTypes = {
  style: PropTypes.object,
};

SendIcon.propTypes = {
  style: PropTypes.object,
};

CameraOffIcon.propTypes = {
  style: PropTypes.object,
};

CameraOnIcon.propTypes = {
  style: PropTypes.object,
};

MicOffIcon.propTypes = {
  style: PropTypes.object,
};

MicOnIcon.propTypes = {
  style: PropTypes.object,
};

VolumeOff.propTypes = {
  style: PropTypes.object,
};

VolumeLow.propTypes = {
  style: PropTypes.object,
};

VolumeMed.propTypes = {
  style: PropTypes.object,
};

VolumeHigh.propTypes = {
  style: PropTypes.object,
};

MoreHorizontal.propTypes = {
  style: PropTypes.object,
};

UserWhite.propTypes = {
  style: PropTypes.object,
};
